import { StyleObject } from 'styletron-react';

export const BADGE_CONTAINER: StyleObject = {
  position: 'absolute',
  top: '8px',
  right: '8px',
  display: 'grid',
  gridTemplateColumns: 'repeat(3, auto)',
  gridColumnGap: '2px',
};
